import * as React from 'react';

import Printer16 from './Printer16';

export const printer16 = () => <Printer16 />;

export default {
    title: 'Icon/Fill/Printer16',
    component: Printer16,
    parameters: {
        notes: "`import Printer16 from 'box-ui-elements/es/icon/fill/Printer16';`",
    },
};
